import "../../style/form/productorderform.scss";
import { useDispatch, useSelector } from "react-redux";
import { productorder } from "../../redux/reducer/counterslice";
import { useEffect, useState, useMemo, Fragment } from "react";
import { ProductOrderGet, trackorder, pharmacytrackorder, product_return } from "../../../text/apidata";
import axios from "axios";
import "rsuite/dist/rsuite.css";
import Swal from "sweetalert2";


function PharmacyProductReturn(props) {
    const productstate = useSelector((state) => state.counter.productorder);
    const productid = useSelector((state) => state.counter.productorderid);
    const dispatch = useDispatch();
    const [alert, setalert] = useState(false);
    const [inputFields, setInputFields] = useState([
    ]);
    const [totalamount, settotalamount] = useState(0);
    const [data, setdata] = useState({})

    console.log(data, "data")
    useEffect(() => {
        if (props.trackorderidp != "") {
            console.log(props.trackorderidp, "props.trackorderidp");
            axios({
                method: "get",
                url: pharmacytrackorder + props.trackorderidp + "/",
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token") + "",
                },
            })
                .then((res) => {
                    // settrackorderdatap(res.data.data);
                    console.log(res.data.data.order.cart_products, "sdsd");
                    // order_id: res.data.data?.order?.id, patient_id: res.data.data?.order?.patient?.id,
                    const object = []
                    res.data.data.order.cart_products.map((ele) => {
                        object.push({ id: ele.id, medicine_name: ele.medicine_name, quantity: ele.quantity, r_quantity: "", r_totalamount: "" })
                        setInputFields(prevInputFields => [
                            ...prevInputFields,
                            { id: ele.id, medicine_name: ele.medicine_name, singleprice: ele.single_price, quantity: ele.quantity, r_quantity: ele.r_quantity, r_totalamount: ele.r_totalamount }
                        ]);
                    })
                    setdata({
                        ...data,
                        order_id: res.data.data?.order?.id,
                        patient_id: res.data.data?.order?.patient?.id,
                        // details: object
                    })
                })
                .catch((error) => {
                    props.popupalert("true");
                    props.popuptext("TrackOrder does not exist.");
                    setTimeout(() => {
                        props.popupalert("false");
                    }, 2000);
                    props.loaderchange("false");
                });
        }
    }, [props.trackorderidp]);

    const cancelnewuser = () => {
        if (alert) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, revert it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    //Swal.fire("Reverted!", "Given Info has been Removed.", "success");
                    props.setreturnpopup(false)
                    setalert(false);
                }
            });
        } else {
            props.setreturnpopup(false)
            setalert(false);
        }
    };
    const handleSubmit = (event) => {
        event.preventDefault();
    };
    const handleRemoveFields = (index) => {
        const values = [...inputFields];
        values.splice(index, 1);
        setInputFields(values);
    };
    const handleInputChange = (index, event) => {
        setalert(true)
        const values = [...inputFields];
        // if (event.target.name === "r_quantity") {
        //     values[index].r_quantity = Number(event.target.value);
        // } 
        if (event.target.name === "r_quantity") {
            // If the value is greater than quantity, set it to quantity
            values[index].r_quantity = Math.min(event.target.value, values[index].quantity);
        }

        if (event.target.name === "r_totalamount") {
            values[index].r_totalamount = Number(event.target.value);
        } else {
            values[index].r_totalamount = values[index].singleprice * event.target.value;
        }

        setInputFields(values);

        // setdata({
        //     ...data,
        //     details: values
        // })

        const updatedDetails = values.map((item, idx) => {
            if (idx === index && item.r_quantity !== "" && item.r_totalamount !== "") {
                return item;
            }
            return null;
        }).filter(item => item !== null);

        const updatedData = {
            ...data,
            details: data.details ? [...data.details.filter((_, i) => i !== index), ...updatedDetails] : updatedDetails
        };

        setdata(updatedData);
    };
    const total_amount = () => {
        let totalamount_calculated = 0
        inputFields.map((item, key) => {
            totalamount_calculated += item.totalamount
        })
        settotalamount(totalamount_calculated)
        console.log(totalamount_calculated, "totak")

    }
    const handleAddFields = () => {
        const values = [...inputFields];
        values.push({
            medicine_name: "",
            single_price: 0,
            quantity: 1,
            totalamount: 0,
        });
        setInputFields(values);
    };
    const newusercreate = (e) => {
        console.log(inputFields)

        Swal.fire({
            title: "Do you want to Save",
            showCancelButton: true,
            confirmButtonText: "Generate Request",
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                props.loaderchange("true");
                axios({
                    method: "post",
                    url: product_return,
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token") + "",
                    },
                    data: data,
                })
                    .then((res) => {
                        console.log(res);
                        Swal.fire({
                            title: "Good job!",
                            text: "Product Returned!",
                            icon: "success"
                        });
                        props.setreturnpopup(false)

                        props.loaderchange("false");
                    })
                    .catch((err) => {
                        console.log(err);
                        props.loaderchange("false");
                    });
            }
        });
    }
    return (
        <>
            <div className="maincontainer_productform">
                <div className="parent-productform">
                    <div className="create-productform card">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                {productstate == "Edit"
                                    ? "Product Order Edit"
                                    : "Product Order Create"}
                            </h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={(e) => cancelnewuser(e)}
                            >
                                <i class="bi bi-x-lg"></i>
                            </button>
                        </div>

                        <div class="modal-body" style={{ padding: "0 !important" }}>
                            <form
                                style={{ padding: "0 1.5rem 0rem" }}
                                className="formspace"
                                onSubmit={handleSubmit}
                            >
                                {inputFields.length > 0 && inputFields.map((inputField, index) => {
                                    return (
                                        <Fragment key={`${inputField}~${index}`}>
                                            <div class="form-row">
                                                <div class="form-group col-md-3 p-1 m-0">
                                                    <label for="validationCustom01" class="form-label">
                                                        Product Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id="validationCustom01"
                                                        name="medicine_name"
                                                        autoComplete="off"
                                                        value={inputField.medicine_name}
                                                        onKeyDown={(e) => {
                                                            if (e.target.value.length === 0 && e.which === 32) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            handleInputChange(index, e);
                                                        }}
                                                        readOnly
                                                    ></input>
                                                </div>
                                                <div class="form-group col-md-2 p-1 m-0">
                                                    <label for="validationCustom01" class="form-label">
                                                        Product Quantity
                                                    </label>
                                                    <input
                                                        type="number"
                                                        class="form-control"
                                                        id="validationCustom01"
                                                        name="quantity"
                                                        autoComplete="off"
                                                        value={inputField.quantity}

                                                        onKeyDown={(e) => {
                                                            if (e.target.value.length === 0 && e.which === 32) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onWheel={(e) => {
                                                            document.activeElement.blur();
                                                        }}
                                                        readOnly
                                                    ></input>
                                                </div>
                                                <div class="form-group col-md-3 p-1 m-0">
                                                    <label for="validationCustom01" class="form-label">
                                                        Return quantity
                                                    </label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id="validationCustom01"
                                                        name="r_quantity"
                                                        autoComplete="off"
                                                        value={inputField.r_quantity}
                                                        onKeyDown={(e) => {
                                                            if (e.target.value.length === 0 && e.which === 32) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            handleInputChange(index, e);
                                                        }}
                                                    ></input>
                                                </div>
                                                <div class="form-group col-md-2 p-1 m-0">
                                                    <label for="validationCustom01" class="form-label">
                                                        Amount
                                                    </label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        id="validationCustom01"
                                                        name="r_totalamount"
                                                        autoComplete="off"
                                                        onChange={(e) => {
                                                            handleInputChange(index, e);
                                                        }}
                                                        value={
                                                            inputField.r_totalamount
                                                        }
                                                        onKeyDown={(e) => {
                                                            if (e.target.value.length === 0 && e.which === 32) {
                                                                e.preventDefault();
                                                            }
                                                        }}

                                                    ></input>
                                                </div>
                                                {/* <div className="form-group col-md-2">
                                                    <button
                                                        className="btn btn-link"
                                                        type="button"
                                                        style={{ top: "25px", position: "relative", fontSize: "25px" }}
                                                        disabled={index === 0}
                                                        onClick={() => handleRemoveFields(index)}
                                                    >
                                                        -
                                                    </button>
                                                    <button
                                                        className="btn btn-link"
                                                        type="button"
                                                        style={{ top: "25px", position: "relative", fontSize: "25px" }}
                                                        onClick={() => handleAddFields()}
                                                    >
                                                        +
                                                    </button>
                                                </div> */}
                                            </div>
                                        </Fragment>
                                    );
                                })}
                                <div
                                    class="form-row"
                                    style={{
                                        display: "flex",
                                        flexFlow: "row wrap",
                                        placeContent: "center space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <div class="form-group col-md-12 pb-3 pt-4 m-0">
                                        <button
                                            class="btn btn-primary"
                                            type="submit"
                                            disabled={alert ? false : true}
                                            onClick={(e) => newusercreate(e)}
                                        >
                                            Save
                                        </button>
                                        <button
                                            class="btn btn-danger"
                                            style={{ float: "right" }}
                                            onClick={(e) => cancelnewuser(e)}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default PharmacyProductReturn



